import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials sends the auth cookies for admin routes. It's harmless for
// public GETs, and required for /api/auth/* + /api/admin/* to work.
const client = axios.create({ baseURL: API, withCredentials: true });

export const api = {
  categories: () => client.get("/categories").then((r) => r.data),
  category: (slug) => client.get(`/categories/${slug}`).then((r) => r.data),
  articles: (params = {}) => client.get("/articles", { params }).then((r) => r.data),
  featured: (limit = 5) =>
    client.get("/articles/featured", { params: { limit } }).then((r) => r.data),
  trending: (limit = 6) =>
    client.get("/articles/trending", { params: { limit } }).then((r) => r.data),
  article: (slug) => client.get(`/articles/${slug}`).then((r) => r.data),
  related: (slug, limit = 3) =>
    client.get(`/articles/${slug}/related`, { params: { limit } }).then((r) => r.data),
  search: (q) => client.get("/articles/search", { params: { q } }).then((r) => r.data),
  subscribe: (email) =>
    client.post("/newsletter/subscribe", { email }).then((r) => r.data),
  contact: (data) => client.post("/contact", data).then((r) => r.data),
  stats: () => client.get("/stats").then((r) => r.data),
  // Auth
  authLogin: (email, password) =>
    client.post("/auth/login", { email, password }).then((r) => r.data),
  authMe: () => client.get("/auth/me").then((r) => r.data),
  authLogout: () => client.post("/auth/logout").then((r) => r.data),
  // Admin
  adminGenerateNow: () =>
    client.post("/admin/generate-now").then((r) => r.data),
};

// Utility: FastAPI 422 returns `detail: [{msg,...}]`; unwrap safely for UI.
export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
